module.exports = __webpack_public_path__ + "img/brand.305a6e77.png";